var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.66602H3.66671C2.93033 6.66602 2.33337 7.26297 2.33337 7.99935V13.3327C2.33337 14.0691 2.93033 14.666 3.66671 14.666H13C13.7364 14.666 14.3334 14.0691 14.3334 13.3327V7.99935C14.3334 7.26297 13.7364 6.66602 13 6.66602Z",
    stroke: "#14161A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33337 4C4.33337 3.46957 4.54409 2.96086 4.91916 2.58579C5.29423 2.21071 5.80294 2 6.33337 2H10.3334C10.8638 2 11.3725 2.21071 11.7476 2.58579C12.1227 2.96086 12.3334 3.46957 12.3334 4V6.66667H4.33337V4Z",
    stroke: "#14161A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockon);
export default __webpack_public_path__ + "static/media/lockon.be39cfe747dd6a6e92f80b89381721ac.svg";
export { ForwardRef as ReactComponent };